import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import QRCode from '~/images/shared/scan-barcode-filled.svg';

const QrCodeButton: React.FC<{
  color: 'primary' | 'green';
  onClick: () => void;
}> = ({ color, onClick }) => {
  const { t } = useTranslation('onboarding');

  return (
    <div
      color={color}
      onClick={onClick}
      className={clsx(
        'flex h-fit min-h-[43px] w-full max-w-[170px] cursor-pointer items-center justify-center gap-2 rounded-[0.8rem] px-20 py-2 text-white desktop:gap-1 desktop:p-2',
        color === 'primary' && 'bg-primary-default',
        color === 'green' && 'bg-secondary-20'
      )}
    >
      <span className='text-24'>
        <QRCode />
      </span>
      <span className='text-14 font-medium'>{t('qr-code')}</span>
    </div>
  );
};

export { QrCodeButton };
